export const container =
  'container 2xl:max-w-[1400px] xl:max-w-[1200px] lg:max-w-[1000px] xmd:max-w-[800px] md:max-w-[690px] sm:max-w-[510px] xs:max-w-[80%] mx-auto'
export const fontStyle =
  "className='text-gray-900 text-[12px] navs:text-[14px] mx-1 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 md:p-0 font-medium"
export const imageStyle = 'w-[160px] h-auto mt-5'
export const responsiveParagraph = 'text-[14px] sm:text-[16px]'
export const responsiveHeading = 'text-2xl sm:text-3xl md:text-4xl'
export const listItem = "list-disc ml-7 leading-6";